module.exports = __webpack_public_path__ + "img/last-name.d1001709.svg";